import PropTypes from 'prop-types';
import React from 'react';

const BadgeCampaign = ({ className }) => {
	return (
		<>
			<div
				className={`bg-campaign rounded-pill d-flex align-items-center justify-content-center badge-campaign mt-2 me-2 ${className}`}
			>
				<span className="text-center xxs fw-800">
					{'Super'}
					<br />
					{'deals'}
				</span>
			</div>
			{/*
					<div className={`bg-red-dark text-danger badge ms-1 ${className}`}>
						<span className="">{t('t1')}</span>
					</div>
					*/}
		</>
	);
};

BadgeCampaign.propTypes = {
	className: PropTypes.string,
	discount: PropTypes.string,
	price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	price_discount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BadgeCampaign;
